module.exports = __webpack_public_path__ + "img/close.395fe32d.svg";